module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"recordInProgress":"Идет запись","notifyAboutRecord":"Не забудьте перед началом записи предупредить об этом кандидата"}}')
  delete Component.options._Ctor
}
